import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/AiAdminTestsPage.css';
import AiAdminCapabilityTestsPanel from './AiAdminCapabilityTestsPanel';
import AiWebSearchTestPanel from './AiWebSearchTestPanel';
import AiMcpTestPanel from './AiMcpTestPanel';
import SystemIngestionApiTestPanel from './SystemIngestionApiTestPanel';

const TABS = [
  { id: 'capability', label: 'Capability Tests', icon: 'fas fa-flask' },
  { id: 'web-search', label: 'Web Search Test', icon: 'fas fa-search' },
  { id: 'mcp', label: 'MCP Test', icon: 'fas fa-plug' },
  { id: 'ingestion-api', label: 'Ingestion API', icon: 'fas fa-network-wired' },
];

function AiAdminTestsPage() {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('capability');
  const [message, setMessage] = useState(null);

  if (!user || (user.accountType !== 'admin' && user.accountType !== 'superadmin')) {
    return (
      <div className="ai-admin-tests-page">
        <div className="alert alert-error">
          <i className="fas fa-exclamation-circle"></i>
          You do not have permission to access the system test suite.
        </div>
      </div>
    );
  }

  return (
    <div className="ai-admin-tests-page">
      <h1>
        <i className="fas fa-vials"></i> System Test
      </h1>

      {message && (
        <div className={`alert alert-${message.type}`}>
          <i className={`fas fa-${message.type === 'success' ? 'check-circle' : 'exclamation-circle'}`}></i>
          <div className="alert-body">
            <div>{message.text}</div>
            {message.details && (
              <pre className="alert-error-details">{message.details}</pre>
            )}
          </div>
        </div>
      )}

      <div className="ai-tests-tabs" role="tablist" aria-label="System test sections">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.id}
            className={`ai-tests-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => {
              setActiveTab(tab.id);
              setMessage(null);
            }}
          >
            <i className={tab.icon} aria-hidden />
            {tab.label}
          </button>
        ))}
      </div>

      <div className="ai-tests-tab-panel" role="tabpanel">
        {activeTab === 'capability' && (
          <AiAdminCapabilityTestsPanel setMessage={setMessage} />
        )}
        {activeTab === 'web-search' && (
          <AiWebSearchTestPanel setMessage={setMessage} />
        )}
        {activeTab === 'mcp' && (
          <AiMcpTestPanel setMessage={setMessage} />
        )}
        {activeTab === 'ingestion-api' && (
          <SystemIngestionApiTestPanel setMessage={setMessage} />
        )}
      </div>
    </div>
  );
}

export default AiAdminTestsPage;
